import OWContainer from 'styles/styled-components/ow-container';
import useController from '../controllers/places-controller';
import { MaterialReactTable } from 'material-react-table';

export const PlacesRoute = () => {
    const { tableSettings } = useController();

    return (
        <OWContainer>
            <MaterialReactTable table={tableSettings} />
        </OWContainer>
    );
};
